<div class="wrapper" [style.top]="top" [style.background-color]="background" [class.is-relative]="isRelative">
  <div class="inner">
    <div class="loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
